import { app } from '../../app';
import { Controller } from './sp-editable-label.controller';

app.component('spEditableLabel', {
    bindings: {
        initialValue: '<',
        inputMaxLength: '<',
        inputPattern: '<',
        isOptional: '<',
        onSave: '&',
    },
    controller: Controller,
    templateUrl: require('./sp-editable-label.html'),
});



// WEBPACK FOOTER //
// ./src/portal/components/sp-editable-label/sp-editable-label.component.js